<script>
	import { getSectionColors } from './helpers';
	import "../shared.css";
	
	export let type;

	$: colors = getSectionColors(type);
</script>

<div class="section" style="--bgc:{colors.background};--b:{colors.border ?? 'unset'}">
	<div class="padding-strip" style="--c:{colors.stripOverride ?? colors.label}" />
	<div class="ops-container">
		<slot labelColor={colors.label} textColor={colors.textOverride} />
	</div>
</div>

<style lang="scss">
	.section {
		width: 98%;
		border-radius: 0 calc(var(--height) / 50.125) calc(var(--height) / 50.125) 0; //0 8px 8px 0;
		background-color: var(--bgc);
		border: var(--b);
		overflow: hidden;
	}
	.padding-strip {
		min-width: 4%;
		height: 100%;
		background-color: var(--c);
	}
	:global(.mission) .padding-strip {
		min-width: calc(var(--height) / 100.25); // 4px;
	}
	.ops-container {
		flex-direction: column;
		gap: calc(var(--height) / 200.50); //2px;
		/* padding: 2px 6px 2px 4px; */
	}
</style>
